import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminBadges } from '@/api/(admin)/badges';
import type { AdminBadge } from '@/api/(admin)/badges/types';

/** Prefix for every badges cache entry, so one invalidation clears list + details. */
export const badgesQueryKey = ['admin', 'badges'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function badgesQueryOptions() {
  return queryOptions({
    queryKey: [...badgesQueryKey, 'list'] as const,
    queryFn: fetchAdminBadges,
  });
}

export function useBadges() {
  const query = useQuery(badgesQueryOptions());
  const rows: AdminBadge[] = query.data ?? [];
  return { ...query, rows };
}
